import React, { useState, useEffect } from 'react';
import { useGlobalContext } from './GlobalStateContext';
import Chart from 'react-apexcharts';
import Select from 'react-select';
import LoadingAnimation from './LoadingAnimation';


// Custom styles for react-select
const customStyles = {
  control: (provided) => ({
    ...provided,
    borderRadius: '12px',
    cursor: 'pointer',
    padding: '8px',
    boxShadow: 'none',
    borderColor: '#e2e8f0',
    '&:hover': {
      borderColor: '#cbd5e0',
    },
  }),
  menu: (provided) => ({
    ...provided,
    borderRadius: '12px',
    boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)',
    cursor: 'pointer',
  }),
  multiValue: (provided) => ({
    ...provided,
    borderRadius: '8px',
    backgroundColor: '#e2e8f0',
    color: '#1a202c',
    cursor: 'pointer',
  }),
  multiValueLabel: (provided) => ({
    ...provided,
    color: '#1a202c',
    cursor: 'pointer',
  }),
  multiValueRemove: (provided) => ({
    ...provided,
    color: '#1a202c',
    cursor: 'pointer',
    ':hover': {
      backgroundColor: '#cbd5e0',
      color: '#1a202c',
    },
  }),
}; 


const SarTimeArchivesChart = ({ selectedFromDate, selectedToDate, onDateChange, combinedFieldOptions }) => {
  const { selectedFeedlot, fetchSarTimeArchivesData } = useGlobalContext();
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);
  const [delta, setDelta] = useState(7)
  const [daysArr, setDaysArr] = useState([])
  const [selectedFields, setSelectedFields] = useState([{ value: 'motor1', label: 'Motor #1 Amps', system: "sartime" }]);
  const [chartData, setChartData] = useState({
    options: {
      chart: {
        type: 'area',
        height: 350,
        zoom: {
          enabled: true,
        },
        toolbar: {
          show: true,
        },
      },
      colors: [
        '#336C8A', '#FF4560', '#4bc0c0', '#00E396', '#FEB019', '#775DD0', '#FF4560', '#4bc0c0', '#00E396', '#FEB019'
      ],
      xaxis: {
        categories: [],
      },
      yaxis: {
        title: {
          text: 'Value',
        }
      },
      legend: {
        position: 'bottom',
        showForSingleSeries: true,
        labels: {},
      },
      tooltip: {
        theme: 'dark',
      },
    },
    
    series: [],
  });
  const [loading, setLoading] = useState(true);
  const [minimumLoadingTimePassed, setMinimumLoadingTimePassed] = useState(false);
  const [noDataAlert, setNoDataAlert] = useState(false);

  
const loadDaysArr = () => {


    fetchSarTimeArchivesData()

  //default to a week ago

  const dates = [];
  let endDate = new Date();
  let startDate = new Date();
  startDate.setDate(startDate.getDate() - 6);

  if (selectedFromDate != null) {
    startDate = new Date(selectedFromDate);
    startDate.setHours(0, 0, 0, 0);
    
  }

  if (selectedToDate != null) {
    endDate = new Date(selectedToDate);
    endDate.setHours(0, 0, 0, 0);
  }
 

  let i = 0
  while (startDate <= endDate) {

      
      const formatted = startDate.toISOString().split('T')[0];
      dates.push(formatted);


      startDate.setDate(startDate.getDate() + 1);
      i++;
    }

    setDelta(i)

    return dates;

}

  const startLoading = () => {
    setLoading(true);
    setMinimumLoadingTimePassed(false);
    setTimeout(() => {
      setMinimumLoadingTimePassed(true);
    }, 2000); // Set minimum loading time to 2 seconds
  };

  const stopLoading = () => {
    setLoading(false);
  };


useEffect(() => {
  // Calculate default values
  const today = new Date();
  const oneWeekAgo = new Date();
  oneWeekAgo.setDate(today.getDate() - 6);

  // Use selected dates or defaults if null
  setFromDate(selectedFromDate ? new Date(selectedFromDate).getTime() : oneWeekAgo.getTime());
  setToDate(selectedToDate ? new Date(selectedToDate).getTime() : today.getTime());


  setDaysArr(loadDaysArr())
  

}, [selectedFromDate, selectedToDate]); // Runs when props change

useEffect(() => {


  // Notify parent if needed
  if (onDateChange) {
      onDateChange({ fromDate, toDate });
  }
}, [fromDate, toDate]);

  useEffect(() => {



    const fetchData = async() => {
      startLoading();

        if (selectedFeedlot && selectedFields.length > 0) {


            setNoDataAlert(false)

            let completeChartData = []


            for (let i = 0; i < selectedFields.length; i++) {
                const data = await fetchSarTimeArchivesData(selectedFeedlot.SarTimeID, selectedFields[i], fromDate, toDate, daysArr)

                completeChartData.push(data)

            }


            if (completeChartData.length > 0 && completeChartData[0].values && completeChartData[0].values.length === 0) {
              setNoDataAlert(true)
            }


            let newSeries = completeChartData.map((data, index) => {

                return {
                    name: selectedFields[index].label,
                    data: data.values
                }
                
            })

            
            
          setChartData({
            options: {
              ...chartData.options,
              xaxis: {
                categories: daysArr
              },

              dataLabels: {
                enabled: true,
                formatter: function(val, opt) {
                  if (val == 0) {
                    return "N/A" 
                  } else {
                    return val
                  }
                  
                }
              },
            },
            series: newSeries,

            
          });

  
          if (minimumLoadingTimePassed) {
            stopLoading();
          } else {
            const loadingTimeout = setTimeout(stopLoading, 2000);
            return () => clearTimeout(loadingTimeout);
          }
       
        }

           
        }

        
        
    

    fetchData()

  },[selectedFeedlot, selectedFields, fromDate, toDate]);
  

  const handleFieldChange = (selectedOptions) => {
    setSelectedFields(selectedOptions);
  };

  return (
    <div className="rounded-lg">
      {!selectedFeedlot && (
        <div className="col-span-2 md:col-span-3 lg:col-span-4 bg-indigo-200 text-blue-600 p-4 rounded-lg shadow-3xl flex items-center">
          <svg className='className="w-6 h-6 text-gray-100 mr-2' viewBox="0 0 24 24" version="1.1"  fill="#000000"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <title>information_fill</title> <g id="页面-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"> <g id="System" transform="translate(-672.000000, -48.000000)" fill-rule="nonzero"> <g id="information_fill" transform="translate(672.000000, 48.000000)"> <path d="M24,0 L24,24 L0,24 L0,0 L24,0 Z M12.5934901,23.257841 L12.5819402,23.2595131 L12.5108777,23.2950439 L12.4918791,23.2987469 L12.4918791,23.2987469 L12.4767152,23.2950439 L12.4056548,23.2595131 C12.3958229,23.2563662 12.3870493,23.2590235 12.3821421,23.2649074 L12.3780323,23.275831 L12.360941,23.7031097 L12.3658947,23.7234994 L12.3769048,23.7357139 L12.4804777,23.8096931 L12.4953491,23.8136134 L12.4953491,23.8136134 L12.5071152,23.8096931 L12.6106902,23.7357139 L12.6232938,23.7196733 L12.6232938,23.7196733 L12.6266527,23.7031097 L12.609561,23.275831 C12.6075724,23.2657013 12.6010112,23.2592993 12.5934901,23.257841 L12.5934901,23.257841 Z M12.8583906,23.1452862 L12.8445485,23.1473072 L12.6598443,23.2396597 L12.6498822,23.2499052 L12.6498822,23.2499052 L12.6471943,23.2611114 L12.6650943,23.6906389 L12.6699349,23.7034178 L12.6699349,23.7034178 L12.678386,23.7104931 L12.8793402,23.8032389 C12.8914285,23.8068999 12.9022333,23.8029875 12.9078286,23.7952264 L12.9118235,23.7811639 L12.8776777,23.1665331 C12.8752882,23.1545897 12.8674102,23.1470016 12.8583906,23.1452862 L12.8583906,23.1452862 Z M12.1430473,23.1473072 C12.1332178,23.1423925 12.1221763,23.1452606 12.1156365,23.1525954 L12.1099173,23.1665331 L12.0757714,23.7811639 C12.0751323,23.7926639 12.0828099,23.8018602 12.0926481,23.8045676 L12.108256,23.8032389 L12.3092106,23.7104931 L12.3186497,23.7024347 L12.3186497,23.7024347 L12.3225043,23.6906389 L12.340401,23.2611114 L12.337245,23.2485176 L12.337245,23.2485176 L12.3277531,23.2396597 L12.1430473,23.1473072 Z" id="MingCute" fill-rule="nonzero"> </path> <path d="M12,2 C17.5228,2 22,6.47715 22,12 C22,17.5228 17.5228,22 12,22 C6.47715,22 2,17.5228 2,12 C2,6.47715 6.47715,2 12,2 Z M11.99,10 L11,10 C10.4477,10 10,10.4477 10,11 C10,11.51285 10.386027,11.9355092 10.8833761,11.9932725 L11,12 L11,16.99 C11,17.5106133 11.3938293,17.9392373 11.8999333,17.9940734 L12.01,18 L12.5,18 C13.0523,18 13.5,17.5523 13.5,17 C13.5,16.6710222 13.3411062,16.3791012 13.0958694,16.1968582 L13,16.1338 L13,11.01 C13,10.4893867 12.6060836,10.0607627 12.1000493,10.0059266 L11.99,10 Z M12,7 C11.4477,7 11,7.44772 11,8 C11,8.55228 11.4477,9 12,9 C12.5523,9 13,8.55228 13,8 C13,7.44772 12.5523,7 12,7 Z" id="形状" fill="#2b73da"> </path> </g> </g> </g> </g></svg>
          Select a Feedlot to view data.
        </div>
      )}
      {noDataAlert && selectedFeedlot && (
        <div className="col-span-2 md:col-span-3 lg:col-span-4 bg-red-200 text-red-700 p-4 rounded-lg shadow-3xl flex items-center">
          <svg className='className="w-6 h-6 text-gray-100 mr-2' viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" fill="#000000"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <title>alert_fill</title> <g id="页面-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"> <g id="System" transform="translate(-286.000000, -240.000000)"> <g id="alert_fill" transform="translate(286.000000, 240.000000)"> <path d="M24,0 L24,24 L0,24 L0,0 L24,0 Z M12.5934901,23.257841 L12.5819402,23.2595131 L12.5108777,23.2950439 L12.4918791,23.2987469 L12.4918791,23.2987469 L12.4767152,23.2950439 L12.4056548,23.2595131 C12.3958229,23.2563662 12.3870493,23.2590235 12.3821421,23.2649074 L12.3780323,23.275831 L12.360941,23.7031097 L12.3658947,23.7234994 L12.3769048,23.7357139 L12.4804777,23.8096931 L12.4953491,23.8136134 L12.4953491,23.8136134 L12.5071152,23.8096931 L12.6106902,23.7357139 L12.6232938,23.7196733 L12.6232938,23.7196733 L12.6266527,23.7031097 L12.609561,23.275831 C12.6075724,23.2657013 12.6010112,23.2592993 12.5934901,23.257841 L12.5934901,23.257841 Z M12.8583906,23.1452862 L12.8445485,23.1473072 L12.6598443,23.2396597 L12.6498822,23.2499052 L12.6498822,23.2499052 L12.6471943,23.2611114 L12.6650943,23.6906389 L12.6699349,23.7034178 L12.6699349,23.7034178 L12.678386,23.7104931 L12.8793402,23.8032389 C12.8914285,23.8068999 12.9022333,23.8029875 12.9078286,23.7952264 L12.9118235,23.7811639 L12.8776777,23.1665331 C12.8752882,23.1545897 12.8674102,23.1470016 12.8583906,23.1452862 L12.8583906,23.1452862 Z M12.1430473,23.1473072 C12.1332178,23.1423925 12.1221763,23.1452606 12.1156365,23.1525954 L12.1099173,23.1665331 L12.0757714,23.7811639 C12.0751323,23.7926639 12.0828099,23.8018602 12.0926481,23.8045676 L12.108256,23.8032389 L12.3092106,23.7104931 L12.3186497,23.7024347 L12.3186497,23.7024347 L12.3225043,23.6906389 L12.340401,23.2611114 L12.337245,23.2485176 L12.337245,23.2485176 L12.3277531,23.2396597 L12.1430473,23.1473072 Z" id="MingCute" fill-rule="nonzero"> </path> <path d="M15.3137,2 C15.8441,2 16.3529,2.21071 16.7279,2.58579 L21.4142,7.27208 C21.7893,7.64715 22,8.15586 22,8.68629 L22,15.3137 C22,15.8441 21.7893,16.3529 21.4142,16.7279 L16.7279,21.4142 C16.3528,21.7893 15.8441,22 15.3137,22 L8.68629,22 C8.15586,22 7.64715,21.7893 7.27208,21.4142 L2.58579,16.7279 C2.21071,16.3528 2,15.8441 2,15.3137 L2,8.68629 C2,8.15586 2.21071,7.64715 2.58579,7.27208 L7.27208,2.58579 C7.64715,2.21071 8.15586,2 8.68629,2 L15.3137,2 Z M12,15 C11.4477,15 11,15.4477 11,16 C11,16.5523 11.4477,17 12,17 C12.5523,17 13,16.5523 13,16 C13,15.4477 12.5523,15 12,15 Z M12,6 C11.48715,6 11.0644908,6.38604429 11.0067275,6.88337975 L11,7 L11,13 C11,13.5523 11.4477,14 12,14 C12.51285,14 12.9355092,13.613973 12.9932725,13.1166239 L13,13 L13,7 C13,6.44772 12.5523,6 12,6 Z" id="形状" fill="#e81127"> </path> </g> </g> </g> </g></svg>
         No data is available for the selected feedlot. Please choose a different feedlot or contact our office for assistance.
        </div>
      )}

      {selectedFeedlot && !noDataAlert && (
        <div>
          <div className="flex flex-col justify-center items-center">
            <div className="flex-1 text-center md:text-left text-xl shadow-3xl rounded-lg p-4 m-1 self-center">
              <h1 className="text-xl md:text-3xl">Average Data</h1>
              <p className="text-base md:text-lg mt-2">
                Choose fields from the dropdown below to visualize their average data.
              </p>
            </div>
          </div>

          <div className="w-full">
            <div className="mb-4 flex justify-center">
              <Select
                isMulti
                value={selectedFields}
                onChange={handleFieldChange}
                options={combinedFieldOptions}
                className="p-2 border rounded shadow-3xl m-3 w-full max-w-xl"
                styles={customStyles}
              />
            </div>
            <div className="rounded-lg shadow-3xl p-4">
              {loading ? (
                <div className="col-span-2 lg:col-span-4 m-10 flex justify-center items-center">
                  <LoadingAnimation />
                </div>
              ) : (
                <Chart options={chartData.options} series={chartData.series} type="area" height={350} />
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default SarTimeArchivesChart;
